<template>
  <div>
    <div id="uoloaddiv35" align="left">
      <el-button type="button" @click="dialogVisible = true" class="margingbot10">申请入驻电台</el-button>

      <el-dialog title="申请入驻:" :visible.sync="dialogVisible" width="30%">
        <div class="shenqingdiantai123">
          <el-select v-model="diantaileixing" placeholder="选择电台类型">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="shenqingdiantai123">
          <el-input placeholder="电台名字" v-model="diantainame" maxlength="10" show-word-limit>
            <template slot="prepend">NAME:</template>
          </el-input>
        </div>

        <div class="shenqingdiantai123">
          <el-input
            type="textarea"
            placeholder="电台描述"
            v-model="diantaidetail"
            maxlength="100"
            show-word-limit
          >
            <template slot="prepend">DETAIL:</template>
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="click_shenqingdiantai">确 定</el-button>
        </span>
      </el-dialog>


      <el-tabs v-model="activeName" @tab-click="handleClickdiantaitab">
        <el-tab-pane label="我的电台" name="wodediantai">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-form label-position="left" inline class="demo-table-expand">
                  <el-form-item label="名字">
                    <span>{{ props.row.name }}</span>
                  </el-form-item>
                  <el-form-item label="分类">
                    <span>{{ props.row.kind }}</span>
                  </el-form-item>
                  <el-form-item label="大类">
                    <span>{{ props.row.mkind }}</span>
                  </el-form-item>
                  <el-form-item label="描述">
                    <span>{{ props.row.detail }}</span>
                  </el-form-item>
                  <el-form-item label="状态">
                    <span>{{ props.row.type }}</span>
                  </el-form-item>
                  <el-form-item label="地址">
                    <span>{{ props.row.md5md5 }}</span>
                  </el-form-item>
                  <el-form-item label="开关">
                    <el-switch
                      v-model="props.row.enable"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-value="1"
                      @change="ablediantai( props.$index, tableData)"
                      inactive-value="0"
                    ></el-switch>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column label="电台" prop="icon" width="350px">
              <template slot-scope="props">
                <div class="item">
                  <div class="left">
                    <img src="src/assets/logo.png" alt="#" />
                  </div>
                  <div class="right">
                    <h4>{{props.row.name}}</h4>
                    <p>{{props.row.detail}}</p>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="分类" prop="kind"></el-table-column>
            <el-table-column label="状态" prop="type"></el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="网络电台" name="wangluodiantai">
          <el-table :data="tableDatawl" style="width: 100%">
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-form label-position="left" inline class="demo-table-expand">
                  <el-form-item label="名字">
                    <span>{{ props.row.name }}</span>
                  </el-form-item>
                  <el-form-item label="分类">
                    <span>{{ props.row.kind }}</span>
                  </el-form-item>
                  <el-form-item label="大类">
                    <span>{{ props.row.mkind }}</span>
                  </el-form-item>
                  <el-form-item label="描述">
                    <span>{{ props.row.detail }}</span>
                  </el-form-item>
                  <el-form-item label="状态">
                    <span>{{ props.row.type }}</span>
                  </el-form-item>
                  <el-form-item label="地址">
                    <span>{{ props.row.md5md5 }}</span>
                  </el-form-item>
                  <el-form-item label="开关">
                    <el-switch
                      v-model="props.row.enable"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-value="1"
                      @change="ablediantai( props.$index, tableData)"
                      inactive-value="0"
                    ></el-switch>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column label="电台" prop="icon" width="350px">
              <template slot-scope="props">
                <div class="item">
                  <div class="left">
                    <img src="src/assets/logo.png" alt="#" />
                  </div>
                  <div class="right">
                    <h4>{{props.row.name}}</h4>
                    <p>{{props.row.detail}}</p>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="分类" prop="kind"></el-table-column>
            <el-table-column label="收藏" prop="type">
              <template slot-scope="props">
                <img class="icon" v-show="props.row.enable==1" src="src/assets/star_fill.jpg" alt />
                <img class="icon" v-show="props.row.enable==0" src="src/assets/star.jpg" alt />
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="电台收藏" name="diantaishouchang">
          <el-table :data="tableDatawlCollected" style="width: 100%">
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-form label-position="left" inline class="demo-table-expand">
                  <el-form-item label="名字">
                    <span>{{ props.row.name }}</span>
                  </el-form-item>
                  <el-form-item label="分类">
                    <span>{{ props.row.kind }}</span>
                  </el-form-item>
                  <el-form-item label="大类">
                    <span>{{ props.row.mkind }}</span>
                  </el-form-item>
                  <el-form-item label="描述">
                    <span>{{ props.row.detail }}</span>
                  </el-form-item>
                  <el-form-item label="状态">
                    <span>{{ props.row.type }}</span>
                  </el-form-item>
                  <el-form-item label="地址">
                    <span>{{ props.row.md5md5 }}</span>
                  </el-form-item>
                  <el-form-item label="开关">
                    <el-switch
                      v-model="props.row.enable"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-value="1"
                      @change="ablediantai( props.$index, tableData)"
                      inactive-value="0"
                    ></el-switch>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column label="电台" prop="icon" width="350px">
              <template slot-scope="props">
                <div class="item">
                  <div class="left">
                    <img src="src/assets/logo.png" alt="#" />
                  </div>
                  <div class="right">
                    <h4>{{props.row.name}}</h4>
                    <p>{{props.row.detail}}</p>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="分类" prop="kind"></el-table-column>
            <el-table-column label="收藏" prop="type">
              <template slot-scope="props">
                <img class="icon" v-show="props.row.enable==1" src="src/assets/star_fill.jpg" alt />
                <img class="icon" v-show="props.row.enable==0" src="src/assets/star.jpg" alt />
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>

      <div style="padding:10px 0;">
        <a-player
          :autoplay="autoplay"
          :music="songList"
          v-if="flag"
          mutex
          listmaxheight="10px"
          ref="player"
        ></a-player>
      </div>
      <!-- <el-table :data="tableDatafilelist" highlight-current-row border style="width: 800px" >
        <el-table-column type="index" width="100" label="编号"></el-table-column>
        <el-table-column prop="filename" label="文件名" width="300"></el-table-column>
        <el-table-column prop="filesize" label="文件大小" width="100" ></el-table-column>
        <el-table-column label="试听" width="100" align="center">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="playurl(scope.$index, tableDatafilelist)"
              type="text"
              size="small"
            >播放</el-button>
          </template>
        </el-table-column>
        <el-table-column v-if="isroot"  label="审核" width="100" align="center">
          <template slot-scope="scope">
            <el-switch
              active-value="1"
              inactive-value="0"
              v-model="tableDatafilelist[scope.$index].enable"
              @change="abletask( scope.$index, tableDatafilelist)"
            ></el-switch>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="deleteRow(scope.$index, tableDatafilelist)"
              type="text"
              size="small"
            >移除</el-button>
          </template>
        </el-table-column>
      </el-table>-->
    </div>
  </div>
</template>

<script>
import VueAplayer from "vue-aplayer";
import axios from "axios";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};
let Base64 = require("js-base64").Base64;
export default {
  components: {
    //别忘了引入组件
    "a-player": VueAplayer
  },
  data() {
    return {
      flag: false,
      actions: "",
      actionsmp3: "",
      dialogVisible: false,
      userid: 0,
      fileList: [],
      diantainame: "",
      diantaidetail: "",
      tableDatafilelist: [],
      activeName: "wangluodiantai",

      songList: [],
      autoplay: false,
      isroot: false,
      diantaileixing: "",
      tableData: [],
      tableDatawl: [],
      tableDatawlCollected: [],
      options: [
        {
          value: 0,
          label: "专用电台"
        },
        {
          value: 1,
          label: "网络电台"
        }
      ]
    };
  },

  created() {
    this.reflush_wodediantai();
    this.userid = sessionStorage.getItem("id");
    //     this.actions =
    //       "http://193.112.4.188:10080/uploader.php?username=" +
    //       sessionStorage.getItem("username") +
    //       "&passwd=" +
    //       sessionStorage.getItem("passwd") +
    //       "&kind=mp3";
    //     this.actionsmp3 =
    //       "http://193.112.4.188:10080/uploader.php?username=" +
    //       sessionStorage.getItem("username") +
    //       "&passwd=" +
    //       sessionStorage.getItem("passwd") +
    //       "&kind=mp3";
    //     this.get_file_list();
    if (sessionStorage.getItem("master_id") == -1) {
      this.isroot = true;
    }
  },
  methods: {
    handleClickdiantaitab(tab, event) {
      if (tab.name == "wodediantai") {
      }
    },
    ablediantai(index, rows) {
      console.log(index);
      console.log(rows[index].id);
      console.log(rows[index].enable);
      let task_id = rows[index].id;
      axios
        .get("/Change_diantai_statusweb.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd"),
            diantai_id: rows[index].id,
            diantai_enable: rows[index].enable
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.reflush_wodediantai();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    markdiantai(index, rows) {
      let task_id = rows[index].id;
      axios
        .get("/mark_diantai_statusweb.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd"),
            diantai_id: rows[index].id,
            diantai_enable: rows[index].enable
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              reflush_wodediantai();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    click_shenqingdiantai() {
      let diantainame = "";
      let kind = 0;
      let diantaidetail = "";
      if (this.diantaidetail == "") {
        console.log("diantaixiangqingbudui");
        return;
      }
      if (this.diantainame == "") {
        console.log("diantaimingzi budui");
        return;
      }
      if (this.diantaileixing != 0 && this.diantaileixing != 1) {
        console.log("diantaileixing budui");
        return;
      }
      let data = new FormData();
      data.append("username", sessionStorage.getItem("username"));
      data.append("passwd", sessionStorage.getItem("passwd"));
      data.append("detail", this.diantaidetail);
      data.append("diantainame", this.diantainame);
      data.append("kind", this.diantaileixing);
      axios
        .post("/shenqingdiantai.php", data)
        .then(
          function(res) {
            if (res.data.res) {
              reflush_wodediantai();
              this.dialogVisible = false;
            } else {
              this.$notify.success({
                title: "提示",
                message: "已经有正在申请的 频道信息！或者参数有误",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    reflush_wodediantai() {
      axios
        .get("/Get_mydiantai_list.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd")
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              console.log(res.data);
              console.log("hh");
              this.tableDatawlCollected = [];
              for (var i = 0; i < res.data.diantai.length; i++) {
                if (res.data.diantai[i].enable == 1) {
                  this.tableDatawlCollected.push(res.data.diantai[i]);
                }
              }
              this.tableData = res.data.diantai;
              this.tableDatawl = res.data.diantai;
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    playurl(index, rows) {
      this.flag = false;
      console.log(rows[index].url);
      console.log(rows[index].filename);
      let obj = {};
      let murl = rows[index].url;
      let lname = rows[index].filename;
      let auth = "试听上传歌曲";
      obj.title = lname;
      obj.author = auth;
      obj.url = murl;
      //把数据一个个push到songList数组中，在a-player标签中使用 :music="songList" 就OK了
      this.songList = obj;
      this.flag = true;
      this.autoplay = true;
    },
    deleteRow(index, rows) {
      this.$confirm(
        "此操作将永久删除该文件, 是否继续?     " + rows[index].filename,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          let filename = rows[index].filename;
          let fileid = rows[index].id;
          axios
            .get("/del_file.php", {
              params: {
                filename: Base64.encode(filename),
                fileid: fileid,
                username: sessionStorage.getItem("username"),
                passwd: sessionStorage.getItem("passwd"),
                kind: "mp3"
              }
            })
            .then(
              function(res) {
                if (res.data.res) {
                  rows.splice(index, 1);
                  this.get_file_list();
                  this.$message({
                    type: "success",
                    message: "删除成功!" + filename
                  });
                }
              }.bind(this)
            )
            .catch(function(res) {
              console.log(res);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    uploadError(err, file, fileList) {
      this.$message({
        message: "上传文件出错了!",
        type: "error"
      });
    },

    abletask(index, rows) {
      console.log("fuckser");
      axios
        .get("/Change_file_status.php", {
          params: {
            file_id: rows[index].id,
            enable: rows[index].enable
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this._get_timer_tasklist_s(rows[index].task_enable, index);
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    uploadbefore(file) {
      var fileName = new Array();
      fileName = file.name.split(".");
      const extension = fileName[fileName.length - 1] === "mp3";
      const extension2 = fileName[fileName.length - 1] === "MP3";
      const isLt2M = file.size / 1024 / 1024 < 40;
      fileName = file.name.split(".");
      if (!extension && !extension2) {
        this.$message({
          message: "上传文件只能是MK格式!",
          type: "warning"
        });
        return false;
      }
      if (!isLt2M) {
        this.$message({
          message: "上传模板大小不能超过 40MB!",
          type: "warning"
        });
        return false;
      }
      return true;
    },
    uploadbeforemp3(file) {
      var fileName = new Array();
      fileName = file.name.split(".");
      const extension = fileName[fileName.length - 1] === "mp3";
      const extension2 = fileName[fileName.length - 1] === "MP3";
      const isLt2M = file.size / 1024 / 1024 < 40;
      fileName = file.name.split(".");
      if (!extension && !extension2) {
        this.$message({
          message: "上传文件只能是MP3格式!",
          type: "warning"
        });
        return false;
      }
      if (!isLt2M) {
        this.$message({
          message: "上传模板大小不能超过 40MB!",
          type: "warning"
        });
        return false;
      }
      return true;
    },
    uploadSuccess(response, file, fileList) {
      console.log("上传文件", response);
      this.get_file_list();
    },
    uploadSuccessmp3(response, file, fileList) {
      console.log("上传文件", response);
      this.get_file_list();
    },
    get_file_list() {
      axios
        .get("/Get_file_List.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd"),
            kind: "mp3"
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.tableDatafilelist = res.data.file;
              this.tableDatafilelist.forEach((item, index) => {
                item.filename = Base64.decode(item.filename);
                item.filesize = item.filesize;
              });
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
#uoloaddiv35 {
  margin: 20px;
  width: 800px;
}
#topbuttn {
  width: 800px;
}
.shenqingdiantai123 {
  margin-top: 10px;
}
.margingbot10 {
  margin-bottom: 10px;
}

.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.item {
  display: flex;
  height: 80px;
  .left {
    width: 100px;
    align-items: center;
    img {
      height: 80px;
    }
  }
  .right {
    padding-left: 10px;
    flex: 1;
    h4 {
      margin-top: 10px;
    }
    p {
      color: #c0c4cc;
      text-overflow: ellipsis;
    }
  }
}
.icon {
  width: 25px;
  height: 25px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/xxxvue/diantai.vue